/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Connect_Drawer_HintInputs */

const cs_portals_connect_drawer_hint = /** @type {(inputs: Portals_Connect_Drawer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Údaje kanceláře pro tento portál. Nikdy se neukážou makléřům.`)
};

const en_portals_connect_drawer_hint = /** @type {(inputs: Portals_Connect_Drawer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office credentials for this portal. Never shown to brokers.`)
};

/**
* | output |
* | --- |
* | "Office credentials for this portal. Never shown to brokers." |
*
* @param {Portals_Connect_Drawer_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_connect_drawer_hint = /** @type {((inputs?: Portals_Connect_Drawer_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Connect_Drawer_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_connect_drawer_hint(inputs)
	return cs_portals_connect_drawer_hint(inputs)
});